import React, { useContext } from 'react';
import { AppContext } from '../../Context/Context';

export const WhatsappWidget = () => {
    const [state] = useContext(AppContext);

    if (!state.widgetWhatsappEnabled || !state.urlWidgetWhatsapp) {
        return null;
    }

    return (
        <a
            href={state.urlWidgetWhatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-widget"
        >
            <img src="/images/iconwa.png" alt="WhatsApp" />
        </a>
    );
};
